var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.numberOfObjects > 0
      ? _c("label", { staticClass: "form-label-div" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("ObjectToChange") +
                  " " +
                  _vm.numberOfObjects.toString() +
                  " " +
                  _vm.$tc("Object", 2).toLowerCase() +
                  "?"
              ) +
              "\n  "
          )
        ])
      : _c("label", { staticClass: "form-label-div" }, [
          _vm._v("\n    " + _vm._s(_vm.$t("NoObjectToChange")) + "\n  ")
        ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "margin-top": "10px" } },
      [
        _c(
          "v-btn",
          {
            staticClass: "button-processing ma-0",
            attrs: { small: "", text: "", color: "accent" },
            on: {
              click: function($event) {
                return _vm.$emit("change-to-default")
              }
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("Cancel")) + "\n    ")]
        ),
        _vm._v(" "),
        _vm.numberOfObjects > 0
          ? _c(
              "v-btn",
              {
                staticClass: "button-processing ma-0",
                attrs: { small: "" },
                on: {
                  click: function($event) {
                    return _vm.$emit("finish-processing")
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("Confirm")) + "\n    ")]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c2f5e37", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c2f5e37","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/Processing/ProcessingWarning.vue
// module id = null
// module chunks = 